import Phaser from 'phaser'
import {
    _setHamburgerIsOpen,
    _setIsSelectingShips,
    _setLastSelectedShipId,
} from '../app/app'
import handleShipPointerDown from '../ship/pointer-down'
import handleTowablePointerDown from '../towable/pointer-down'

const bindShipSelectPointerEvents = (Config) => {
    const graphics = Config.scene.add.graphics({
        lineStyle: {width: 2, color: 0x6653d7},
    })
    let rect
    let draw = false
    let startX = 0
    let startY = 0

    graphics[Config.namespace] = {type: 'ship select box'}
    graphics.setDepth(7)

    Config.scene.input.on('pointerdown', function(pointer) {
        if (!Config.isSelectingShips) {
            return
        }

        startX = pointer.worldX
        startY = pointer.worldY
        draw = true
    })

    Config.scene.input.on('pointerup', function() {
        graphics.clear()
        _setIsSelectingShips(false)
        draw = false
    })

    Config.scene.input.on('pointermove', function(pointer) {
        if (!draw) {
            return
        }

        const endX = pointer.worldX - startX
        const endY = pointer.worldY - startY
        const width = Math.abs(endX)
        const height = Math.abs(endY)
        let x
        let y

        // Left
        if (endX < 0) {
            // Top
            x = pointer.worldX
            y = pointer.worldY

            // Bottom
            if (endY > 0) {
                y = startY
            }
        }

        // Right
        if (endX > 0) {
            // Bottom
            x = startX
            y = startY

            // Top
            if (endY < 0) {
                y = pointer.worldY
            }
        }

        rect = new Phaser.Geom.Rectangle(x, y, width, height)

        graphics.clear()
        graphics.strokeRectShape(rect)

        Object.keys(Config.ships).forEach((key) => {
            const ship = Config.ships[key]

            if (ship.faction.includes(Config.enemyFactionName)) {
                return
            }

            const size = ship.formationRadius
            const shipRect = new Phaser.Geom.Rectangle(
                ship.x - size / 2,
                ship.y - size / 2,
                size,
                size
            )

            // Draw debug graphics
            // const graphics2 = Config.scene.add.graphics({
            //     lineStyle: {width: 1, color: 0xffff00},
            // })
            // graphics2.clear()
            // graphics2.strokeRectShape(shipRect)
            // graphics2.setDepth(16)

            const intersection = Phaser.Geom.Intersects.GetRectangleIntersection(
                rect,
                shipRect
            )

            if (intersection.width) {
                Config.selectedShips[key] = ship.name
                ship.selected = true
                _setLastSelectedShipId(ship.id)
            } else {
                delete Config.selectedShips[key]
                ship.selected = false
            }
        })
    })
}

export const bindScenePointerEvents = (
    Config,
    parallaxStars1,
    parallaxStars2
) => {
    // Board Click
    Config.scene.input.on('pointerdown', () => {
        const {worldX, worldY} = Config.scene.input.activePointer

        for (const key in Config.entities) {
            Config.entities[key].handlePointerdown(worldX, worldY)
        }

        handleTowablePointerDown(worldX, worldY)
        handleShipPointerDown(worldX, worldY)
    })

    bindShipSelectPointerEvents(Config)

    const camera = Config.scene.cameras.main
    const moveBoundaryPadding = Config.boardPadding / 2
    let lastPinchZoom

    // Pinch Zoom
    // https://phaser.discourse.group/t/using-multitouch-for-pinch-to-zoom/243
    const dragScale = Config.scene.plugins
        .get('rexpinchplugin')
        .add(Config.scene)
    dragScale
        .on('drag1', (dragScale) => {
            _setHamburgerIsOpen(false)
            if (Config.isSelectingShips) {
                return
            }

            const drag1Vector = dragScale.drag1Vector
            camera.scrollX -= drag1Vector.x / camera.zoom
            camera.scrollY -= drag1Vector.y / camera.zoom

            // Stop parallax effect when near boundaries
            if (
                camera.worldView.x <= 0 - moveBoundaryPadding ||
                camera.worldView.y <= 0 - moveBoundaryPadding ||
                camera.worldView.x + camera.worldView.width >=
                    camera._bounds.width -
                        Config.boardPadding * 2 +
                        moveBoundaryPadding ||
                camera.worldView.y + camera.worldView.height >=
                    camera._bounds.height -
                        Config.boardPadding * 2 +
                        moveBoundaryPadding
            ) {
                return
            }

            parallaxStars1.blitter.x -= drag1Vector.x / camera.zoom / 4
            parallaxStars1.blitter.y -= drag1Vector.y / camera.zoom / 4

            parallaxStars2.blitter.x += drag1Vector.x / camera.zoom / 4
            parallaxStars2.blitter.y += drag1Vector.y / camera.zoom / 4
        })
        .on(
            'pinch',
            (pinch) => {
                const scaleFactor = pinch.scaleFactor

                if (lastPinchZoom) {
                    // Zooming out
                    if (lastPinchZoom > camera.zoom) {
                        if (camera.zoom < Config.zoomMin) {
                            lastPinchZoom = Config.zoomMin
                            camera.zoomTo(Config.zoomMin, 0, 'Linear', true)
                            return
                        }
                    }
                    // Zooming in
                    if (lastPinchZoom < camera.zoom) {
                        if (camera.zoom > Config.zoomMax) {
                            lastPinchZoom = Config.zoomMax
                            camera.zoomTo(Config.zoomMax, 0, 'Linear', true)
                            return
                        }
                    }
                }

                lastPinchZoom = camera.zoom
                camera.zoomTo((camera.zoom *= scaleFactor), 0, 'Linear', true)
            },
            Config.scene
        )
}
